import { Typography } from "@mui/material";
import TextField from "@imminently/decisively-ui/TextField";
import SelectField from "@imminently/decisively-ui/SelectField";
import FormPanel from "@imminently/decisively-ui/FormPanel";
import { useIsProjectTechnicalWriter } from "@/auth/permissions";
import TextArea from "@imminently/decisively-ui/TextArea";

const LabelOptions = [
  {
    value: "automatic",
    label: "Automatic",
  },
  {
    value: "separate",
    label: "Separate",
  },
  {
    value: "inline",
    label: "Inline",
  },
];

const hint = "Used during the interview process and by configured bots, on how this attribute should be answered.";

export const AttributeMetadata = () => {
  const canEdit = useIsProjectTechnicalWriter();

  return (
    <FormPanel>
      <Typography>Default information displayed to the user. Can be overridden per interview.</Typography>
      <FormPanel>
        <TextField
          name="label"
          label="Label"
          disabled={!canEdit}
          fullWidth
        />
        <SelectField
          name="labelDisplay"
          label="Label display"
          options={LabelOptions}
          disabled={!canEdit}
          fullWidth
        />
        <TextField
          inputComponent={TextArea}
          rows={6}
          helperText={hint}
          name="explanation"
          label="Explanation"
          disabled={!canEdit}
          fullWidth
        />
      </FormPanel>
    </FormPanel>
  );
};
